import { get } from 'lodash';

import { getObjValue } from '@/utils/helper';

import {
	LOGIN,
	LOGIN_SUCCESS,
	LOGIN_ERROR,
	LOGOUT_CLEANUP,
	GET_USER_INFO_SUCCESS,
	GET_USER_INFO_ERROR,
	GET_USER_PERMISSIONS,
	GET_USER_PERMISSIONS_SUCCESS,
	GET_USER_PERMISSIONS_ERROR,
	REQUEST_OTP,
	REQUEST_OTP_ERROR,
	REQUEST_OTP_SUCCESS,
	RESENT_OTP,
	FORGOT_PASSWORD,
	FORGOT_PASSWORD_ERROR,
	RESET_FORGOT_PASSWORD,
	FORGOT_PASSWORD_SUCCESS,
	CHANGE_PASSWORD,
	CHANGE_PASSWORD_ERROR,
	CHANGE_PASSWORD_SUCCESS,
	SAVE_LOCAL_USER_INFO,
	VERIFY_USER,
	VERIFY_USER_SUCCESS,
	VERIFY_USER_ERROR,
	UPDATE_USER_GROUP,
	UPDATE_USER_GROUP_ERROR,
	UPDATE_USER_GROUP_SUCCESS,
	GET_USER_GROUP_LIST,
	GET_USER_GROUP_LIST_SUCCESS,
	GET_USER_GROUP_LIST_ERROR,
	RESET_USER_GROUP_LIST,
	SAVE_MID_DATA,
	SET_CAPTCHA_TOKEN,
	SET_CAPTCHA_ERROR,
} from './types';

export const initialState = {
	loading: false,
	getOtp: false,
	forgotPassword: false,
	passwordSet: false,
	verifyUser: {
		loading: false,
		error: undefined,
		token: undefined,
		setPassword: undefined,
	},
	user: {
		phoneNumber: '',
		permissions: { loading: false },
		email: '',
		userId: '',
		groups: [],
		token: '',
		groupSelection: false,
	},
	captcha: { value: '', error: undefined },
	userGroupsList: [],
	userGroupListLoader: false,
	userGroupListError: undefined,
	selectedMID: undefined,
	notificationType: '',
};

function login(state = initialState, action) {
	switch (action.type) {
		case LOGIN:
		case FORGOT_PASSWORD:
		case RESENT_OTP:
		case CHANGE_PASSWORD:
			return {
				...state,
				loading: true,
				error: undefined,
				notificationType: '',
			};
		case LOGIN_SUCCESS:
			if (action.data.token && action.data.expiry) {
				return {
					...state,
					loading: false,
					user: {
						...state.user,
						phoneNumber: action.endpoint,
						token: action.data.token,
					},
					getOtp: true,
					error: undefined,
					notificationType: '',
				};
			}
			return {
				...state,
				loading: false,
				user: {
					...state.user,
					phoneNumber: action.data.phone,
					email: action.data.email,
					userId: action.data.userId,
					groups: action.data.groups,
					groupSelection: action.data.groupSelection,
				},
				error: undefined,
				notificationType: '',
			};
		case LOGIN_ERROR:
			return {
				...state,
				loading: false,
				error: action.error,
				notificationType: 'error',
				errorMessage: get(action, 'error.message'),
			};
		case REQUEST_OTP:
			return {
				...state,
				requestOTP: true,
				error: undefined,
				user: {
					...state.user,
					phoneNumber: '',
					token: '',
				},
				notificationType: '',
			};
		case REQUEST_OTP_SUCCESS:
			return {
				...state,
				requestOTP: false,
				user: {
					...state.user,
					phoneNumber: action.phoneNumber,
					token: action.data.token,
				},
				getOtp: true,
				error: undefined,
				notificationType: '',
			};
		case REQUEST_OTP_ERROR:
			return {
				...state,
				requestOTP: false,
				error: action.error,
				getOtp: false,
				user: {
					...state.user,
					phoneNumber: '',
					token: '',
				},
				notificationType: 'error',
				errorMessage: get(action, 'error.message'),
			};
		case FORGOT_PASSWORD_SUCCESS:
			return {
				...state,
				loading: false,
				forgotPassword: true,
				error: undefined,
				notificationType: '',
			};
		case FORGOT_PASSWORD_ERROR:
			return {
				...state,
				loading: false,
				forgotPassword: false,
				error: action.error,
				notificationType: 'error',
				errorMessage: get(action, 'error.message'),
			};
		case RESET_FORGOT_PASSWORD:
			return {
				...state,
				loading: false,
				forgotPassword: false,
			};
		case CHANGE_PASSWORD_SUCCESS:
			return {
				...state,
				loading: false,
				passwordSet: true,
				error: undefined,
				notificationType: '',
			};
		case CHANGE_PASSWORD_ERROR:
			return {
				...state,
				loading: false,
				passwordSet: false,
				error: action.error,
				notificationType: 'error',
				errorMessage: get(action, 'error.message'),
			};
		case GET_USER_PERMISSIONS:
			return {
				...state,
				user: {
					...state.user,
					permissions: {
						...state.user.permissions,
						loading: true,
					},
				},
			};
		case GET_USER_PERMISSIONS_SUCCESS:
			return {
				...state,
				user: {
					...state.user,
					permissions: {
						...state.user.permissions,
						loading: false,
						data: action.data,
						error: undefined,
					},
				},
			};
		case GET_USER_PERMISSIONS_ERROR:
			return {
				...state,
				user: {
					...state.user,
					permissions: {
						...state.user.permissions,
						loading: false,
						error: action.error,
					},
				},
			};
		case GET_USER_INFO_SUCCESS:
			return {
				...state,
				user: {
					...state.user,
					...action.data,
					userInfoError: undefined,
				},
			};
		case GET_USER_INFO_ERROR:
			return {
				...state,
				user: {
					...state.user,
					...action.data,
					userInfoError: action.error,
				},
			};
		case SAVE_LOCAL_USER_INFO:
			return {
				...state,
				user: {
					...state.user,
					...action.userInfo,
					permissions: {
						...getObjValue(state, 'user.permissions'),
						data: action.userPermissions,
					},
					roles: {
						...getObjValue(state, 'user.roles'),
						data: action.userRoles,
					},
				},
				userGroupsList: action.userGroupsList,
				selectedMID: action.selectedMID,
			};

		case UPDATE_USER_GROUP:
			return {
				...state,
				userGroupLoader: true,
				selectedMID: undefined,
			};
		case UPDATE_USER_GROUP_SUCCESS:
			return {
				...state,
				userGroupLoader: false,
				userGroupError: undefined,
			};
		case UPDATE_USER_GROUP_ERROR:
			return {
				...state,
				userGroupLoader: false,
				userGroupError: action.error,
				selectedMID: undefined,
			};

		case LOGOUT_CLEANUP:
			return { ...initialState };
		case VERIFY_USER:
			return {
				...state,
				verifyUser: {
					...state.verifyUser,
					loading: true,
					error: undefined,
					token: undefined,
					setPassword: undefined,
				},
				notificationType: '',
			};
		case VERIFY_USER_SUCCESS:
			return {
				...state,
				verifyUser: {
					...action.data,
					loading: false,
					error: undefined,
				},
				notificationType: '',
			};
		case VERIFY_USER_ERROR:
			return {
				...state,
				verifyUser: {
					...state.verifyUser,
					loading: false,
					error: action.error,
				},
				notificationType: 'error',
				errorMessage: get(action, 'error.message'),
			};
		case GET_USER_GROUP_LIST:
			return {
				...state,
				userGroupListLoader: true,
				notificationType: '',
			};
		case GET_USER_GROUP_LIST_SUCCESS:
			return {
				...state,
				userGroupsList: action.data,
				userGroupListError: undefined,
				userGroupListLoader: false,
				notificationType: '',
				getOtp: false,
			};
		case GET_USER_GROUP_LIST_ERROR:
			return {
				...state,
				userGroupsList: [],
				userGroupListError: action.error,
				userGroupListLoader: false,
				notificationType: 'error',
			};
		case RESET_USER_GROUP_LIST:
			return {
				...state,
				userGroupsList: [],
				userGroupListLoader: false,
			};
		case SAVE_MID_DATA:
			return {
				...state,
				selectedMID: action.selectedMID,
			};
		case SET_CAPTCHA_TOKEN:
			return {
				...state,
				captcha: {
					...state.captcha,
					value: action.value,
					error: undefined,
				},
			};
		case SET_CAPTCHA_ERROR:
			return {
				...state,
				captcha: {
					...state.captcha,
					value: '',
					error: action.captchaError,
				},
			};

		default:
			return state;
	}
}

export default login;
